<template>
  <datalist v-if="objects" :id="id">
    <option
      v-for="[name, size] in sizes"
      :key="size"
      :value="size"
      v-html="name"
    />
  </datalist>
</template>

<script lang="ts">
import { contains, filter, last, length, map } from "@pdfking/rfunc"
import { All, Zip } from "@pdfking/tfunc"
import autocomplete from "../constants/autocomplete"

export default {
  components: {},
  computed: {
    objects() {
      const response = autocomplete[this.autocomplete]
      return response ? response.objects : null
    },

    sizes() {
      if (this.objects) {
        const unit_filter = length(this.units)
          ? (formatted: string) => contains(this.units, last(formatted.split(" ")))
          : (_formatted: string) => true

        const is_contained = (measures: number[]) =>
          All(
            Zip(this.min, measures, this.max),
            ([min, current, max]: [number, number, number]) => current >= min && current <= max
          )

        return map(
          ([name, formatted, ..._sizes]: [string, string, ...number[]]) => [name, formatted],
          filter(
            ([_name, formatted, ...sizes]: [string, string, ...number[]]) =>
              unit_filter(formatted) && is_contained(sizes),
            this.objects
          )
        )
      }
      return null
    },
  },

  props: ["id", "autocomplete", "units", "min", "max", "target"] as const,
}
</script>
